import LeadRetrievalInviteRedeem
  from "pages/Unauthenticated/LeadRetrieval/Register/InviteRedeem/LeadRetrievalInviteRedeem"
import { usePublicEvent, useLeadRetrievalLicenseToken } from "queries/events"
import Spinner from "components/elements/Spinner"
import { Center, Heading } from "@chakra-ui/react"
import React from "react"
import { useParams } from "react-router-dom"

const LeadRetrievalInviteRedeemWrapper = () => {
  const { eventId, token } = useParams<{ eventId: string, token: string }>()
  const { data: event, isLoading } = usePublicEvent(eventId)
  const {
    data: tokenResponse, isLoading: isTokenLoading, isError: isTokenError,
  } = useLeadRetrievalLicenseToken(token)

  if (isLoading) {
    return <Spinner />
  }

  if (!event) {
    return <Center h="100vh"><Heading>Event Not Found</Heading></Center>
  }

  return (
    <LeadRetrievalInviteRedeem
      event={event}
      token={token}
      tokenResponse={tokenResponse}
      isTokenLoading={isTokenLoading}
      isTokenError={isTokenError}
    />
  )
}

export default LeadRetrievalInviteRedeemWrapper
